import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditWebhookTemplate = lazy(() =>
  import("@scenes/MessageComposition/Webhook/WebhookTemplates/WebhookTemplateLibrary/EditWebhookTemplate").then(
    (module) => ({
      default: module.EditWebhookTemplate,
    })
  )
);

export const engagementTemplatesAndMediaWebhookTemplatesIdNRO: NavigationRoutingObject = {
  Component: EditWebhookTemplate,
  componentFeatureFlippers: ["webhook_templates_nro_component"],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-webhook-templates-webhook-id-nro-heading", "Webhook Template"),
  pageNameForTracking: () => "Webhook Template",
  icon: "nav-system-webhook-dashed",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    if (!featureOn("webhook")) {
      return false;
    }
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewWebhookTemplates" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
